// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_out[data-v-9ae5883c]{width:100%;text-align:right}.ppp[data-v-9ae5883c]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
